// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"49":"2efecc8c","987":"1529ea8a"}[chunkId] + ".css";
};